import { NamedRoute } from "@/jenesys-types/routes/routes";

import { CompanyPractiseTeamRoute } from "@/components/routes/settings/CompanyPractiseTeamRoute";

// eslint-disable-next-line import/no-anonymous-default-export
export default (): NamedRoute => ({
  name: "settings.company.team",
  path: "team",
  children: [{ index: true, element: <CompanyPractiseTeamRoute /> }]
});
